import CollapsingHeader from './CollapsingHeader/CollapsingHeader';
import styles from './SizeAndWeightStyles.module.css';
import VehiclePersonField from './VehiclePersonField';

const InvolvedPersons = ({
  disabled,
  handleChange,
  dispatch,
  operator,
  operatorAddress,
  operatorPhone,
  carrier,
  carrierAddress,
  carrierPhone,
  owner,
  ownerAddress,
  ownerPhone,
  piss,
  incidentPeople,
  userRoles,
  incidentId,
  printOwner,
  printCarrier, 
  nightMode,
  locked, 
  missingFields = [],
  ...props
}) => {

  return (
    <CollapsingHeader nightMode={nightMode} title={"Involved Persons"} defaultOpen={true}>
      <div className={`${styles['flexColumn']}`}>
        <VehiclePersonField
          disabled={disabled}
          handleChange={handleChange}
          dispatch={dispatch}
          personType={"operator"}
          person={operator}
          address={operatorAddress}
          phone={operatorPhone}
          piss={piss}
          incidentPeople={incidentPeople}
          userRoles={userRoles}
          incidentId={incidentId}
          checked={true}
          locked={locked}
          missingFields={missingFields}
          {...props}
        />
        <VehiclePersonField
          disabled={disabled}
          handleChange={handleChange}
          dispatch={dispatch}
          personType={"carrier"}
          person={carrier}
          address={carrierAddress}
          phone={carrierPhone}
          piss={piss}
          incidentPeople={incidentPeople}
          userRoles={userRoles}
          incidentId={incidentId}
          checked={printCarrier}
          locked={locked}
          missingFields={missingFields}
          {...props}
          />
        <VehiclePersonField
          disabled={disabled}
          handleChange={handleChange}
          dispatch={dispatch}
          personType={"owner"}
          person={owner}
          address={ownerAddress}
          phone={ownerPhone}
          piss={piss}
          incidentPeople={incidentPeople}
          userRoles={userRoles}
          incidentId={incidentId}
          checked={printOwner}
          locked={locked}
          missingFields={missingFields}
          {...props}
        />
      </div>
    </CollapsingHeader>
  );
}

export default InvolvedPersons;